export default "__VITE_ASSET__DoUuUune__"